const SERVICE = 'appointment-service'

const getAppointmentsListApi = async (api, params) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process('/user', params)

const getAppointmentDetailsApi = async (api, id) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process(`/appointment/${id}`)

const getDoctorAppointmentListApi = async (api, params = {}) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process('/doctor', params)

const getDoctorAppointmentOverviewApi = async (api, apptID, params) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process(`/doctor/${apptID}`, params)

module.exports = {
  getAppointmentsListApi,
  getAppointmentDetailsApi,
  getDoctorAppointmentListApi,
  getDoctorAppointmentOverviewApi,
}
